import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=c8c502e6&scoped=true"
import script from "./Form.vue?vue&type=script&lang=ts"
export * from "./Form.vue?vue&type=script&lang=ts"
import style0 from "./Form.vue?vue&type=style&index=0&id=c8c502e6&prod&scoped=true&lang=css"
import style1 from "./Form.vue?vue&type=style&index=1&id=c8c502e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8c502e6",
  null
  
)

export default component.exports